import {
  UPDATE_OFFICE_FILTERS,
  CLEAR_OFFICE_FILTERS,
  UPDATE_AGENT_FILTERS,
  CLEAR_AGENT_FILTERS,
  OFFICE_REQUEST,
  OFFICE_SUCCESS,
  OFFICE_FAILURE,
  AGENT_REQUEST,
  AGENT_SUCCESS,
  AGENT_FAILURE,
} from "actions/masters";

export default (
  state = {
    officeFilters: {},
    agentFilters: {},
    isOfficesFetching: false,
    isAgentsFetching: false,
    offices: [],
    agents: [],
  },
  action
) => {
  switch (action.type) {
    case UPDATE_OFFICE_FILTERS:
      return {
        ...state,
        officeFilters: { ...state.officeFilters, ...action.params },
      };
    case CLEAR_OFFICE_FILTERS:
      return {
        ...state,
        officeFilters: {},
      };
    case UPDATE_AGENT_FILTERS:
      return {
        ...state,
        agentFilters: { ...state.agentFilters, ...action.params },
      };
    case CLEAR_AGENT_FILTERS:
      return {
        ...state,
        agentFilters: {},
      };
    case OFFICE_REQUEST:
      return {
        ...state,
        isOfficesFetching: true,
      };
    case OFFICE_SUCCESS:
      return {
        ...state,
        isOfficesFetching: false,
        offices: action.response,
        error: undefined,
      };
    case OFFICE_FAILURE:
      return {
        ...state,
        isOfficesFetching: false,
        error: action.error,
      };
    case AGENT_REQUEST:
      return {
        ...state,
        isAgentsFetching: true,
      };
    case AGENT_SUCCESS:
      return {
        ...state,
        isAgentsFetching: false,
        agents: action.response,
        error: undefined,
      };
    case AGENT_FAILURE:
      return {
        ...state,
        isAgentsFetching: false,
        error: action.error,
      };

    default:
      return state;
  }
};
